import React from "react";
import * as Bananas from "bananas-commerce-admin";

import { TableBody } from "@mui/material";

import { DetailedPublicationSchema } from "../../types";

import PublicationRow from "./PublicationRow";

export interface PublicationsListProps {
  publications: DetailedPublicationSchema[];
}

const PublicationsList: React.FC<PublicationsListProps> = ({
  publications,
}) => {
  const { t } = Bananas.useI18n();
  return (
    <Bananas.TableCard>
      <Bananas.Table pagination count={publications.length}>
        <Bananas.TableHead>
          <Bananas.TableHeading>{t("Titel")}</Bananas.TableHeading>
          <Bananas.TableHeading>{t("Utgivningsschema")}</Bananas.TableHeading>
          <Bananas.TableHeading>{t("Stopptid")}</Bananas.TableHeading>
          <Bananas.TableHeading>{t("Bokade Annonser")}</Bananas.TableHeading>
          <Bananas.TableHeading>{t("Ordrar totalt")}</Bananas.TableHeading>
        </Bananas.TableHead>
        <TableBody>
          {publications.map((p) => (
            <PublicationRow key={p.abbreviation} publication={p} />
          ))}
        </TableBody>
      </Bananas.Table>
    </Bananas.TableCard>
  );
};

export default PublicationsList;
